import { combineReducers } from '@reduxjs/toolkit';

import settingsSlice from '@/store/settings/settingsSlice';

const settingsReducer = combineReducers({
    settings: settingsSlice,
});

export default settingsReducer;
